// dependecies import ==>
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { ClickAwayListener } from "@material-ui/core";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import Popover from "react-popover";
// assets and scss import ==>
import "./myTransactionsMainContentHeader.scss";
import SortIcon from "../../../../assets/FilterIconGrey.svg";
import Download from "../../../../assets/transactions_download_icon.svg";
import tickIcon from "../../../../assets/tick-thin.svg";
import tickBlueIcon from "../../../../assets/tick-thin-blue.svg";
import Filter from "../../../../assets/Filter_soft_edges.svg";
import info_icon from "../../../../assets/dashboard/info_icon.svg";
import closeBlueIcon from "../../../../assets/close_blue.svg";
// project file import ==>
import TitleSubtitleCard from "../../../common/Modules/TitleSubtitleCard";
import { addQuery, removeQuery } from "../../helper";
import FilterMenuList from "../../../common/Modules/FilterMenuList";
import DatePicker from "../../../common/Modules/DatePicker";
import MobileFilterWithDatePicker from "../../../common/Modules/MobileFilterWithDatePicker";
// constant import ==>
import {
  getDateByRanges,
  SORT_MENU_ITEMS,
} from "../../../DashboardAppointmentsView/Constant";
import {
  AMOUNT_FILTER,
  API_FILTER_LIST,
  CONSULTATION_FILTER,
  DEFAULT_TRANSACTIONS_PAYLOAD,
  FILTER_ICON_TYPE,
  HEADER_LIST,
  HEADER_TYPE_LIST,
  MOBILE_FILTER_LIST,
  PAYMENT_METHOD_FILTER,
  PAYMENT_STATUS_FILTER,
  TRANSACTIONS_HEADER_LIST,
  dateFilter,
} from "../../constants";
import { USER_TYPE } from "../../../../Util/constants";
import RadioButtonWithText from "../../../common/Modules/RadioButtonWithText";
import PrimaryButton from "../../../common/Buttons/PrimaryButton";

const MyTransactionsMainContentHeader = (props) => {
  const {
    transactionsSummary,
    userType,
    doctorRole,
    clinicId,
    sortOrder,
    disableDownload,
    procedureList,
    doctorList,
    selectedDoctorId,
    consultationTypeValue,
    procedureTypeFilterValue,
    paymentStatus,
    paymentMethodValue,
    partialAmountValue,
    startDate,
    endDate,
    transactionDownloadOption,
    handleAccountDetails,
    getTransactions,
    downloadReportApi,
    displaySearchFilter,
    displayTransactionDropdown,
    handleDefaultPayload,
    handleSelectReportType,
  } = props;

  const history = useHistory();
  const location = useLocation();

  const [sort_menu, setSortMenu] = useState(SORT_MENU_ITEMS);
  const [openMenu, setOpenMenu] = useState(false);
  const [transactionsHeader, setTransactionsHeader] = useState(
    TRANSACTIONS_HEADER_LIST
  );
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [appliedRange, setAppliedRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [consultationList, setConsultationList] = useState([]);
  const [selectedHeaderItem, setSelectedHeaderItem] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [applicableHeaderList, setApplicableHeaderList] = useState([]);
  const [showDownloadDropdown, setShowDownloadDropdown] = useState(false);
  const [showDownloadTooltip, setShowDownloadTooltip] = useState(false);

  const TextOnlyTooltip = withStyles({
    tooltip: {
      bottom: "2px",
      color: "#1B2027",
      backgroundColor: "white",
      fontSize: "12px",
      boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    },
  })(Tooltip);

  // Lifecycle Methods ===>

  useEffect(() => {
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.PROCEDURE) {
        list.menuData = getConsultationMenu();
      }
      if (list.type === HEADER_TYPE_LIST.PAYMENT_METHOD) {
        list.menuData = PAYMENT_METHOD_FILTER;
      }
      if (list.type === HEADER_TYPE_LIST.PAYMENT_DATE_STATUS) {
        list.menuData = PAYMENT_STATUS_FILTER;
      }
      if (list.type === HEADER_TYPE_LIST.AMOUNT) {
        list.menuData = AMOUNT_FILTER;
      }
    });

    setTransactionsHeader([...transactionsHeader]);
  }, []);

  useEffect(() => {
    let selectedSort = sortOrder
      ? sortOrder
      : DEFAULT_TRANSACTIONS_PAYLOAD.sort_order;
    let arr = [];
    sort_menu.forEach((menu) => {
      arr.push({
        ...menu,
        selected: menu.value === selectedSort ? true : false,
      });
    });
    setSortMenu([...arr]);
  }, [sortOrder]);

  useEffect(() => {
    setSelectionRange({
      ...selectionRange,
      startDate: new Date(startDate),
      endDate: new Date(endDate),
    });
    setAppliedRange({
      ...appliedRange,
      startDate: new Date(startDate),
      endDate: new Date(endDate),
    });
  }, [startDate, endDate]);

  useEffect(() => {
    let isFilterApplied = !(
      moment(appliedRange?.startDate).format("YYYY MM DD") ===
        moment().format("YYYY MM DD") &&
      moment(appliedRange?.endDate).format("YYYY MM DD") ===
        moment().format("YYYY MM DD")
    );
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.APPNT_DATE_TIME) {
        list.isFilterApplied = isFilterApplied;
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  }, [appliedRange]);

  // To set the selected doctor filter
  useEffect(() => {
    let arr = [];
    if (doctorList) {
      arr.push({
        name: "All",
        value: "all",
        selected:
          !selectedDoctorId || selectedDoctorId.toLowerCase() === "all"
            ? true
            : false,
      });
      doctorList.forEach((doc) => {
        arr.push({
          ...doc,
          doctor_name: doc.prefix_name
            ? doc.doctor_name.replace(doc.prefix_name, doc.prefix_name + ". ")
            : doc.doctor_name,
          name: doc.prefix_name
            ? doc.name.replace(doc.prefix_name, doc.prefix_name + ". ")
            : doc.name,
          selected:
            selectedDoctorId && selectedDoctorId === doc.doctor_id
              ? true
              : false,
        });
      });
      transactionsHeader.forEach((hl) => {
        if (hl.type === HEADER_TYPE_LIST.DOCTOR_NAME) {
          hl.menuData = arr;
          hl.showFilter = false;
          hl.isFilterApplied =
            selectedDoctorId && selectedDoctorId?.toLowerCase() !== "all";
        } else {
          if (hl?.showFilter) {
            hl.showFilter = false;
          }
        }
      });
      setTransactionsHeader([...transactionsHeader]);
    }
  }, [doctorList, selectedDoctorId]);

  useEffect(() => {
    let selectedFilter = consultationTypeValue
      ? consultationTypeValue
      : procedureTypeFilterValue
      ? procedureTypeFilterValue
      : "all";
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.PROCEDURE) {
        list.menuData = getConsultationMenu();
        list.isFilterApplied =
          selectedFilter && selectedFilter?.toLowerCase() !== "all";
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  }, [procedureList, consultationTypeValue, procedureTypeFilterValue]);

  // To set the selected payment status filter
  useEffect(() => {
    let selectedFilter = paymentStatus
      ? paymentStatus
      : DEFAULT_TRANSACTIONS_PAYLOAD.payment_status_filter;
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.PAYMENT_DATE_STATUS) {
        list.menuData.map(
          (menu) =>
            (menu.selected =
              menu.value.toLowerCase() === selectedFilter.toLowerCase()
                ? true
                : false)
        );
        list.isFilterApplied =
          selectedFilter && selectedFilter?.toLowerCase() !== "all";
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  }, [paymentStatus]);

  // To set the selected payment method filter
  useEffect(() => {
    let selectedFilter = paymentMethodValue
      ? paymentMethodValue
      : DEFAULT_TRANSACTIONS_PAYLOAD.payment_method_filter;
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.PAYMENT_METHOD) {
        list.menuData.map(
          (menu) =>
            (menu.selected = menu.value === selectedFilter ? true : false)
        );
        list.isFilterApplied =
          selectedFilter && selectedFilter?.toLowerCase() !== "all";
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  }, [paymentMethodValue]);

  useEffect(() => {
    let selectedFilter = partialAmountValue
      ? partialAmountValue
      : DEFAULT_TRANSACTIONS_PAYLOAD.partial_amount_filter;
    transactionsHeader.forEach((list) => {
      if (list.type === HEADER_TYPE_LIST.AMOUNT) {
        list.menuData.map(
          (menu) =>
            (menu.selected = menu.value === selectedFilter ? true : false)
        );
        list.isFilterApplied =
          selectedFilter && selectedFilter?.toLowerCase() !== "all";
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  }, [partialAmountValue]);

  useEffect(() => {
    if (showMobileFilter) {
      let headerList = transactionsHeader.filter(
        (li) =>
          li.applicableRoles.indexOf(userType) !== -1 ||
          li.applicableRoles.indexOf(doctorRole) !== -1
      );
      let list = [];
      headerList.map((menu) => menu.filterIcon && list.push(menu));
      list.forEach((li, ind) => {
        if (ind === 0) {
          li.showFilter = true;
          handleMobileSelectedItem(li);
        }
        if (li.mobileFilterTitle === MOBILE_FILTER_LIST.DATE) {
          dateFilter[0].selected = true;
          li.menuData = dateFilter;
        }
      });
      setApplicableHeaderList([...list]);
    }
  }, [showMobileFilter]);

  // <===

  // Helper Methods ===>

  const getConsultationMenu = () => {
    let arr = [],
      list = [];
    let selectedFilter = consultationTypeValue
      ? consultationTypeValue
      : procedureTypeFilterValue
      ? procedureTypeFilterValue
      : "all";

    list.push(...CONSULTATION_FILTER, ...procedureList);
    list.forEach((item) => {
      arr.push({
        ...item,
        selected:
          selectedFilter.toLowerCase() === item.value.toLowerCase()
            ? true
            : false,
      });
    });

    return arr;
  };

  const appendFilterToUrl = (item) => {
    let key = "",
      value = "",
      add = false,
      val = selectedHeaderItem,
      filterValue = {};
    if (val.type === HEADER_TYPE_LIST.PROCEDURE) {
      key = [
        API_FILTER_LIST.CONSULTATION,
        API_FILTER_LIST.CONSULTATION_TYPE,
        API_FILTER_LIST.PROCEDURE,
        API_FILTER_LIST.PROCEDURE_VALUE,
        API_FILTER_LIST.PAGENO,
      ];
      if (item.type === "procedure") {
        value = [
          "",
          "",
          item.name,
          item.value,
          DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
        ];
      } else {
        value = [
          item.name,
          item.value,
          "",
          "",
          DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
        ];
      }
      filterValue = {
        [key[0]]: value[0],
        [key[1]]: value[1],
        [key[2]]: value[2],
        [key[3]]: value[3],
        [key[4]]: value[4],
      };

      add = item.value !== "all";
    } else if (val.type === HEADER_TYPE_LIST.PAYMENT_DATE_STATUS) {
      key = [API_FILTER_LIST.PAYMENT_STATUS, API_FILTER_LIST.PAGENO];
      value = [
        item.value.charAt(0).toUpperCase() + item.value.substr(1).toLowerCase(),
        DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
      ];
      filterValue = {
        [key[0]]: value[0],
        [key[1]]: value[1],
      };
      add = item.value !== DEFAULT_TRANSACTIONS_PAYLOAD.payment_status;
    } else if (val.type === HEADER_TYPE_LIST.PAYMENT_METHOD) {
      key = [
        API_FILTER_LIST.PAYMENT_METHOD,
        API_FILTER_LIST.PAYMENT_METHOD_VALUE,
        API_FILTER_LIST.PAGENO,
      ];
      value = [item.name, item.value, DEFAULT_TRANSACTIONS_PAYLOAD.page_no];
      filterValue = {
        [key[0]]: value[0],
        [key[1]]: value[1],
        [key[2]]: value[2],
      };
      add = item.value !== DEFAULT_TRANSACTIONS_PAYLOAD.payment_method_filter;
    } else if (val.type === HEADER_TYPE_LIST.AMOUNT) {
      key = [
        API_FILTER_LIST.AMOUNT_FILTER,
        API_FILTER_LIST.AMOUNT_VALUE,
        API_FILTER_LIST.PAGENO,
      ];
      value = [item.name, item.value, DEFAULT_TRANSACTIONS_PAYLOAD.page_no];
      filterValue = {
        [key[0]]: value[0],
        [key[1]]: value[1],
        [key[2]]: value[2],
      };
      add = item.value !== DEFAULT_TRANSACTIONS_PAYLOAD.partial_amount_filter;
    } else if (val.type === HEADER_TYPE_LIST.DOCTOR_NAME) {
      key = [
        API_FILTER_LIST.DOCTORNAME,
        API_FILTER_LIST.DOCTOR_NAME,
        API_FILTER_LIST.PAGENO,
      ];
      value = [
        item.doctor_id,
        item.doctor_name,
        DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
      ];
      filterValue = {
        [key[0]]: value[0] ? value[0] : "",
        [key[1]]: value[1] ? value[1] : "",
        [key[2]]: value[2],
      };
      add = item.doctor_id;
    } else if (val.type === HEADER_TYPE_LIST.APPNT_DATE_TIME) {
      key = [
        API_FILTER_LIST.STARTDATE,
        API_FILTER_LIST.ENDDATE,
        API_FILTER_LIST.PAGENO,
      ];
      value = [item[0], item[1], DEFAULT_TRANSACTIONS_PAYLOAD.page_no];
      filterValue = {
        [key[0]]: value[0],
        [key[1]]: value[1],
        [key[2]]: value[2],
      };
      add = true;
    }

    if (add) {
      addQuery(history, location, key, value);
    } else {
      removeQuery(history, location, key);
    }

    getTransactions(filterValue);
  };

  const getSelectedAppointmentDate = () => {
    let selectedDate = moment(appliedRange?.startDate).format("MMM DD, YYYY");
    if (
      moment(appliedRange?.startDate).format("YYYY-MM-DD") !==
      moment(appliedRange?.endDate).format("YYYY-MM-DD")
    ) {
      if (
        moment(appliedRange?.startDate).format("YYYY") ===
        moment(appliedRange?.endDate).format("YYYY")
      ) {
        selectedDate = `${moment(appliedRange?.startDate).format(
          "MMM DD"
        )} - ${moment(appliedRange?.endDate).format("MMM DD, YYYY")}`;
      } else {
        selectedDate = `${moment(appliedRange?.startDate).format(
          "MMM DD, YYYY"
        )} - ${moment(appliedRange?.endDate).format("MMM DD, YYYY")}`;
      }
    }

    return selectedDate;
  };

  const handleIndividualFilterClear = () => {
    let index = transactionsHeader.findIndex(
      (list) => list.id === selectedHeaderItem.id
    );

    transactionsHeader[index].menuData.forEach((ele) => (ele.selected = false));
    transactionsHeader[index].showFilter = false;
    setTransactionsHeader([...transactionsHeader]);

    let item = transactionsHeader[index].menuData.find(
      (ele) => ele.value === "all"
    );

    appendFilterToUrl(item);
  };

  const handleSortFilterClear = () => {
    toggleSortItems(SORT_MENU_ITEMS[0]);
  };

  const clearAllFilters = () => {
    handleDefaultPayload();
  };

  // <===

  // Actions ===>

  const toggleSortMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseSortFilter = () => {
    setOpenMenu(false);
  };

  const toggleSortItems = (data) => {
    let sortval;
    SORT_MENU_ITEMS.forEach((item) => {
      item.selected = false;
      if (item.value === data.value) {
        sortval = item.value;
        item.selected = true;
      }
    });
    addQuery(
      history,
      location,
      [API_FILTER_LIST.SORTORDER, API_FILTER_LIST.PAGENO],
      [`${sortval}`, 1]
    );
    getTransactions({
      [API_FILTER_LIST.SORTORDER]: sortval,
      [API_FILTER_LIST.PAGENO]: DEFAULT_TRANSACTIONS_PAYLOAD.page_no,
    });
    handleCloseSortFilter();
  };

  const openMenuList = (val) => {
    let index = transactionsHeader.findIndex((list) => list.id === val.id);
    if (val.filterType === FILTER_ICON_TYPE.PROCEDURE) {
      setConsultationList(transactionsHeader[index].menuData);
    }
    transactionsHeader[index].showFilter =
      !transactionsHeader[index].showFilter;
    setTransactionsHeader([...transactionsHeader]);
    setSelectedHeaderItem(val);
  };

  const handleFilterSearch = (value) => {
    let index = transactionsHeader.findIndex(
      (list) => list.id === selectedHeaderItem.id
    );

    if (transactionsHeader[index].filterType === FILTER_ICON_TYPE.PROCEDURE) {
      const filterData = consultationList.filter((data) =>
        data?.name?.toLowerCase().includes(value?.toLowerCase())
      );
      transactionsHeader[index].menuData = filterData;
      setTransactionsHeader([...transactionsHeader]);
    }
  };

  const toggleItems = (item) => {
    let val = selectedHeaderItem;
    let index = transactionsHeader.findIndex((list) => list.id === val.id);
    transactionsHeader[index].showFilter = false;
    let index1 = transactionsHeader[index].menuData.indexOf(item);
    transactionsHeader[index].menuData.map((data) => (data.selected = false));
    transactionsHeader[index].menuData[index1].selected = true;
    setTransactionsHeader([...transactionsHeader]);
    appendFilterToUrl(item);
  };

  const applyRange = (range) => {
    setAppliedRange(range);
    appendFilterToUrl([
      moment(range.startDate).format("YYYY-MM-DD"),
      moment(range.endDate).format("YYYY-MM-DD"),
    ]);
    closeDatePicker();
  };

  const closeDatePicker = () => {
    transactionsHeader.forEach((hl) => {
      if (hl.type === HEADER_TYPE_LIST.APPNT_DATE_TIME) {
        hl.showFilter = false;
      }
    });
    setTransactionsHeader([...transactionsHeader]);
  };

  const handleClose = (item) => {
    let index = transactionsHeader.findIndex((list) => list.id === item.id);
    transactionsHeader[index].showFilter = false;
    setTransactionsHeader([...transactionsHeader]);
  };

  const handleOnChange = (ranges) => {
    let isMoreThanTwoMonths =
      moment(ranges.endDate).toDate() >
      moment(ranges.startDate).add(2, "months").toDate();

    if (isMoreThanTwoMonths) {
      ranges.endDate = moment(ranges.startDate).add(2, "months").toDate();
    }

    setSelectionRange(ranges);
  };

  const handleShowFilter = () => {
    setShowMobileFilter(true);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const handleCloseMobFilter = () => {
    setShowMobileFilter(false);
    applicableHeaderList.forEach((list) => {
      list.showFilter = false;
      list.menuData.forEach((menu) => {
        menu.selected = false;
      });
    });
    setApplicableHeaderList([...applicableHeaderList]);
  };

  const openMobileMenuList = (val) => {
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    applicableHeaderList.forEach((dh) => {
      dh.showFilter = false;
    });
    applicableHeaderList[index].showFilter = true;
    if (val.filterType === HEADER_TYPE_LIST.PROCEDURE) {
      setConsultationList(applicableHeaderList[index].menuData);
    }
    setApplicableHeaderList([...applicableHeaderList]);
    setSelectedHeaderItem(val);
  };

  const selectMobileFilterOptions = (item) => {
    let val = selectedHeaderItem;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let index1 = applicableHeaderList[index].menuData.indexOf(item);
    applicableHeaderList[index].menuData.map((data) => (data.selected = false));
    applicableHeaderList[index].menuData[index1].selected = true;
    setApplicableHeaderList([...applicableHeaderList]);
  };

  const handleApplyFilter = (selectedValue) => {
    let val = selectedHeaderItem;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let item = applicableHeaderList[index].menuData.filter(
      (menu) => menu.selected
    );
    if (applicableHeaderList[index].type === HEADER_TYPE_LIST.APPNT_DATE_TIME) {
      let range = {};
      if (selectedValue !== "Custom Date Range") {
        range = getDateByRanges(selectedValue);
      } else {
        range = {
          startDate: moment(appliedRange.startDate).format("YYYY-MM-DD"),
          endDate: moment(appliedRange.endDate).format("YYYY-MM-DD"),
        };
      }
      appendFilterToUrl([range.startDate, range.endDate]);
    } else {
      appendFilterToUrl(item[0]);
    }
    handleCloseMobFilter();
  };

  const handleResetAllFilter = () => {
    handleCloseMobFilter();
    clearAllFilters();
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
    setAppliedRange(ranges);
  };

  const handleCloseDownloadDropdown = () => {
    setShowDownloadDropdown(false);
  };

  const handleOpenDownloadDropdown = () => {
    setShowDownloadDropdown(true);
  };

  const handleDownload = () => {
    handleCloseDownloadDropdown();
    downloadReportApi();
  };
  // <===

  // Display UI ===>

  const displayTransactionsHeader = () => {
    return (
      <div className="mtmch-header-container">
        <span className="mtmch-header-left-container">
          <TitleSubtitleCard
            title={transactionsSummary?.noOfTransactions}
            subtitle="Total No. of Transactions"
          />
          <TitleSubtitleCard
            title={"₹" + transactionsSummary?.totalAmount}
            subtitle="Total Amount"
          />
          {clinicId && (
            <TitleSubtitleCard
              title={"₹" + transactionsSummary?.partialAmount}
              subtitle={
                transactionsSummary?.partialAmtCount + " Partial Payment"
              }
            />
          )}
          <TitleSubtitleCard
            title={"₹" + transactionsSummary?.pendingAmount}
            subtitle="Pending Payments"
          />
        </span>
        <span className="mtmch-header-right-container">
          {displaySortFilter()}
          {displayDownloadReportIcon()}
          {displayAccountDetailsBtn()}
        </span>
      </div>
    );
  };

  const displayAccountDetailsBtn = () => {
    return (
      <button
        className={
          `account-details-button ` +
          (userType === USER_TYPE.STAFF
            ? "account-details-button-disabled"
            : "")
        }
        onClick={() =>
          userType === USER_TYPE.STAFF ? "" : handleAccountDetails()
        }
      >
        Account Details
      </button>
    );
  };

  const getCustomRangeLabel = () => {
    return (
      <>
        Custom Date Range
        <Popover
          isOpen={isOpen}
          preferPlace={"below"}
          place={null}
          body={
            <span className="mtmch-popover-msg">
              You can select up to 60 days
            </span>
          }
        >
          <img
            src={info_icon}
            alt=""
            style={{ cursor: "pointer", marginLeft: "6px" }}
            onMouseOver={() => {
              setIsOpen(true);
            }}
            onMouseOut={() => {
              setIsOpen(false);
            }}
          />
        </Popover>
      </>
    );
  };

  const displaySortFilter = () => {
    return (
      <div className="d-flex ai-center transactions-sort-filter">
        <img src={SortIcon} alt="Sort" onClick={toggleSortMenu} />
        <div
          className={
            "mtmch-header-sort-dropdown-hide " +
            (openMenu ? "mtmch-header-sort-dropdown-show" : "")
          }
        >
          {openMenu && (
            <ClickAwayListener onClickAway={handleCloseSortFilter}>
              <div>
                <FilterMenuList
                  menuItemList={sort_menu}
                  tickIcon={tickIcon}
                  selectedTickIcon={tickBlueIcon}
                  toggleItems={toggleSortItems}
                  customFooter={customSortFilterFooter}
                />
              </div>
            </ClickAwayListener>
          )}
        </div>
      </div>
    );
  };

  const displayDownloadReportIcon = () => {
    return (
      <div style={{ position: "relative" }}>
        <TextOnlyTooltip
          title={disableDownload ? "" : "Download Report"}
          open={showDownloadTooltip}
        >
          <div
            className="transactions-download-report"
            onClick={() =>
              disableDownload ? "" : handleOpenDownloadDropdown()
            } //downloadReportApi()
            style={{
              opacity: disableDownload ? "0.5" : "",
            }}
            onMouseOver={() => setShowDownloadTooltip(!showDownloadDropdown)}
            onMouseLeave={() => setShowDownloadTooltip(false)}
          >
            <img
              src={Download}
              className="transaction-filter-icon"
              style={{
                cursor: disableDownload ? "not-allowed" : "",
              }}
              alt=""
            />
          </div>
        </TextOnlyTooltip>

        {showDownloadDropdown && (
          <ClickAwayListener onClickAway={handleCloseDownloadDropdown}>
            <div className="mtmch-transaction-download-list">
              {transactionDownloadOption?.map((report_type, index) => (
                <div
                  className={
                    "mtmch-transaction-radio-btn " +
                    (report_type?.disabled
                      ? "mtmch-transaction-radio-btn-disabled"
                      : "")
                  }
                  key={index}
                >
                  <RadioButtonWithText
                    data={report_type}
                    text={report_type?.label}
                    value={report_type?.value}
                    selected={report_type?.selected}
                    allowClickOnLabel={true}
                    disabled={report_type?.disabled}
                    style={{
                      cursor: report_type?.disabled ? "not-allowed" : "pointer",
                    }}
                    handleChange={handleSelectReportType}
                  />
                </div>
              ))}
              <div className="mtmch-transaction-download-btn">
                <PrimaryButton
                  title="Download"
                  handleButtonClick={handleDownload}
                />
              </div>
            </div>
          </ClickAwayListener>
        )}
      </div>
    );
  };

  const displayFilterApplied = () => {
    return <span className="mtmch-subheader-filter-applied"></span>;
  };

  const displayTransactionsSubheader = () => {
    let headerList = transactionsHeader.filter(
      (list) =>
        list.applicableRoles.indexOf(userType) !== -1 ||
        list.applicableRoles.indexOf(doctorRole) !== -1
    );

    return (
      <div className="mtmch-subheader-container">
        {headerList?.map((hl, ind) => (
          <div key={ind} className="mtmch-subheader">
            {hl.isFilterApplied && displayFilterApplied()}
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="mtmch-subheader-subcontainer"
                onClick={() => openMenuList(hl)}
              >
                {hl.title !== HEADER_LIST.APPNT_DATE_TIME && (
                  <span>{hl.title}</span>
                )}
                {hl.filterIcon && (
                  <span
                    style={{
                      marginLeft:
                        hl.title === HEADER_LIST.APPNT_DATE_TIME ? "" : "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {(hl.type !== HEADER_TYPE_LIST.AMOUNT ||
                      hl.title !== HEADER_LIST.APPNT_DATE_TIME ||
                      clinicId) && (
                      <img
                        src={hl.filterIcon}
                        alt=""
                        className={
                          hl.showFilter &&
                          hl.title !== HEADER_LIST.APPNT_DATE_TIME
                            ? "mtmch-subheader-up-arrow"
                            : "mtmch-subheader-down-arrow"
                        }
                        style={{
                          marginRight:
                            hl.title === HEADER_LIST.APPNT_DATE_TIME
                              ? "8px"
                              : "",
                          paddingBottom:
                            hl.title === HEADER_LIST.APPNT_DATE_TIME
                              ? "2px"
                              : "",
                          width:
                            hl.title === HEADER_LIST.APPNT_DATE_TIME
                              ? "20px"
                              : "",
                        }}
                      />
                    )}
                    {hl.title === HEADER_LIST.APPNT_DATE_TIME && (
                      <span className="mtmch-subheader-appointment-date">
                        {getSelectedAppointmentDate()}
                      </span>
                    )}
                  </span>
                )}
              </div>
              <div
                className={
                  "mtmch-subheader-hide-dropdown " +
                  (hl.showFilter ? "mtmch-subheader-show-dropdown" : "")
                }
              >
                {hl.showFilter && displayNormalFilterList(hl)}
              </div>
            </div>
          </div>
        ))}
        {displayAllClearBtn()}
      </div>
    );
  };

  const displayAllClearBtn = () => {
    let display = transactionsHeader.some((ele) => ele.isFilterApplied);
    return (
      display && (
        <span onClick={clearAllFilters} className="mtmch-subheader-clear-btn">
          <img alt="" src={closeBlueIcon} /> Clear
        </span>
      )
    );
  };

  const customFooter = () => {
    return (
      <span className="mtmch-custom-footer">
        <span
          className="mtmch-custom-footer-btn"
          onClick={handleIndividualFilterClear}
        >
          Clear
        </span>
      </span>
    );
  };

  const customSortFilterFooter = () => {
    return (
      <span className="mtmch-custom-footer">
        <span
          className="mtmch-custom-footer-btn"
          onClick={handleSortFilterClear}
        >
          Clear
        </span>
      </span>
    );
  };

  const displayNormalFilterList = (val) => {
    if (val.filterType !== FILTER_ICON_TYPE.DATE) {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div className={val.className ?? ""}>
            <FilterMenuList
              menuItemList={val.menuData}
              show_filter_searchbar={val?.showFilterSearchbar}
              tickIcon={tickIcon}
              selectedTickIcon={tickBlueIcon}
              placeholderForSearch={val.placeholderForSearch}
              toggleItems={toggleItems}
              handleFilterSearch={handleFilterSearch}
              customFooter={customFooter}
            />
          </div>
        </ClickAwayListener>
      );
    } else {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div>
            <DatePicker
              maxDate={moment(new Date())._d}
              customRangeLabel={getCustomRangeLabel()}
              handleOnChange={handleOnChange}
              closeDatePicker={closeDatePicker}
              applyRange={applyRange}
            />
          </div>
        </ClickAwayListener>
      );
    }
  };

  const displayTransactionsMainHeaderMobileView = () => {
    return (
      <div className="mtmch-main-header-mobile-view">
        <span>My Transactions</span>
        {displayAccountDetailsBtn()}
      </div>
    );
  };

  const displayTransactionsFiltersMobileView = () => {
    return (
      <div className="mtmch-filters-mobile-view-container">
        <span className="mtmch-filters-mobile-view">
          {displaySortFilter()}
          {displayDownloadReportIcon()}
        </span>
        <span>
          {displaySearchFilter()}
          {displayTransactionDropdown()}
        </span>
      </div>
    );
  };

  const displayTransactionsHeaderMobileView = () => {
    return (
      <table class="table table-bordered mtmch-header-mobile-view">
        <tbody>
          <tr>
            <td>
              {" "}
              <TitleSubtitleCard
                title={transactionsSummary?.noOfTransactions}
                subtitle="Total No. of Transactions"
              />
            </td>
            <td>
              <TitleSubtitleCard
                title={"₹" + transactionsSummary?.totalAmount}
                subtitle="Total Amount"
              />
            </td>
          </tr>
          <tr>
            {clinicId && (
              <td>
                <TitleSubtitleCard
                  title={"₹" + transactionsSummary?.partialAmount}
                  subtitle={
                    transactionsSummary?.partialAmtCount + " Partial Payment"
                  }
                />
              </td>
            )}
            <td>
              <TitleSubtitleCard
                title={"₹" + transactionsSummary?.pendingAmount}
                subtitle="Pending Payments"
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const displayTransactionsSubheaderMobileView = () => {
    return (
      <span className="mtmch-subheader-mobile-view">
        <span onClick={handleShowFilter}>
          Filter <img alt="" src={Filter} />
        </span>
      </span>
    );
  };

  const DateTimeRangeRender = () => {
    return (
      <span className="mtmch-date-picker-mobile-view">
        <span className="mtmch-date-picker-mobile-view-note">
          You can select up to 60 days
        </span>
        <DateRangePicker
          ranges={[selectionRange]}
          startDatePlaceholder="From"
          endDatePlaceholder="To"
          showSelectionPreview={true}
          editableDateInputs={true}
          showPreview={false}
          staticRanges={[]}
          inputRanges={[]}
          dragSelectionEnabled={true}
          onChange={(item) => handleSelect(item.selection)}
          maxDate={moment(new Date())._d}
          className="range-only-date m-auto"
        />
      </span>
    );
  };

  // <===

  return (
    <>
      <div className="my-transactions-main-content-header">
        {window.innerWidth < 768 && displayTransactionsMainHeaderMobileView()}
        {window.innerWidth < 768 && displayTransactionsFiltersMobileView()}
        {window.innerWidth > 768
          ? displayTransactionsHeader()
          : displayTransactionsHeaderMobileView()}
        {window.innerWidth > 768
          ? displayTransactionsSubheader()
          : displayTransactionsSubheaderMobileView()}
      </div>
      {showMobileFilter && (
        <MobileFilterWithDatePicker
          showMobileFilter={showMobileFilter}
          menuList={applicableHeaderList}
          selectedMenu={selectedHeaderItem}
          customCancelText="Clear"
          tickIcon={tickIcon}
          selectedTickIcon={tickBlueIcon}
          placeholderForSearch="Search"
          DateTimeRangeRender={DateTimeRangeRender}
          handleClose={handleCloseMobFilter}
          openMobileMenuList={openMobileMenuList}
          handleMobileSelectedItem={handleMobileSelectedItem}
          selectMobileFilterOptions={selectMobileFilterOptions}
          handleApplyFilter={handleApplyFilter}
          handleResetAllFilter={handleResetAllFilter}
          handleFilterSearch={handleFilterSearch}
        />
      )}
    </>
  );
};

export default MyTransactionsMainContentHeader;
